import axios from 'axios'

const API_URL: string = process.env.REACT_APP_API_URL as string
const REQUEST_DASHBOARD_URL = `${API_URL}/dashboard`

export function getDashboardData() {
  return axios.get<any>(REQUEST_DASHBOARD_URL)
}
